class Policy {
    constructor(enabled, title, text, acceptance) {
        this.enabled = enabled;
        this.title = title;
        this.text = text;
        this.acceptance = acceptance;
    }
}
